<template>
  <v-app>
    <Navbar/>
    <div>
      <v-content>
        <v-container grid-list-lg class="view_order">
          <v-layout row wrap>
            <v-flex xs12 md5>
              <v-card>
                <v-card-title><h4>Asiakkaan Tiedot</h4></v-card-title>
                <v-divider></v-divider>
                <v-list dense class="pukulist">              
                  <v-list-tile>
                    <v-list-tile-content><b>Asiakkaan Nimi:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.name}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Sähköposti:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.email}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Puhelinnumero:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.phone}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Maa:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.country}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Kaupunki:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.city}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Toimitusosoite:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{order.address}}</v-list-tile-content>
                  </v-list-tile>               
                </v-list>
                <br><br>
                <v-card-title><h4>Tilauksen Tiedot</h4></v-card-title>
                  <v-divider></v-divider>
                  <v-list dense class="pukulist">               
                    <v-list-tile>
                      <v-list-tile-content><b>Tilausnumero:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end"><b>#{{order.ordernumber}}</b></v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content><b>Esineiden määrä:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end">{{order.quantity}}</v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content><b>Tilauksen tila:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end">{{order.order_status}}</v-list-tile-content>
                    </v-list-tile>   
                       <v-list-tile>
                      <v-list-tile-content><b>Pdf-tila:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end">{{order.pdfready}}</v-list-tile-content>
                    </v-list-tile>   
                    <v-list-tile>
                      <v-list-tile-content><b>Kokonaishinta:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end"><b>{{currency}}{{order.checkout_total}}</b></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <br><br>
                  <div v-if="delivery">               
                    <v-card-title><h4>Toimitustiedot </h4></v-card-title>
                    <v-divider></v-divider>
                    <v-list dense class="pukulist">     
                      <v-list-tile>
                        <v-list-tile-content><b>Toimitusvalvoja:</b></v-list-tile-content>
                        <v-list-tile-content class="align-end">{{delivery.admin_person_name}}</v-list-tile-content>
                      </v-list-tile>          
                      <v-list-tile>
                        <v-list-tile-content><b>Tilaushenkilö:</b></v-list-tile-content>
                        <v-list-tile-content class="align-end">{{delivery.delivery_person_name}}</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content><b>Tilauspäivä:</b></v-list-tile-content>
                        <v-list-tile-content class="align-end">{{delivery.date}}</v-list-tile-content>
                      </v-list-tile>   
                      <v-list-tile>
                        <v-list-tile-content><b>Tilausaika:</b></v-list-tile-content>
                        <v-list-tile-content class="align-end">{{delivery.time}}</v-list-tile-content>
                      </v-list-tile>
                      <!-- <v-list-tile>
                        <v-list-tile-content><b>Toimituksen tila:</b></v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          <b>Tämä järjestys on {{order.order_status}} </b>
                        </v-list-tile-content>
                      </v-list-tile> -->
                    </v-list>
                  </div>       
                  <div v-else>
                    <v-divider></v-divider>
                    <v-list dense class="pukulist">
                      <v-list-tile>
                        <v-list-tile-content><b>Admin</b></v-list-tile-content>
                          <v-flex xs6>
                            <v-select                    
                              v-bind:items="adminPerson"
                              v-model="admin_person_id"
                              label="Valitse Ylläpitäjä"
                              item-text="name"
                              item-value="id"
                              single-line                      
                            ></v-select>
                          </v-flex>                    
                        </v-list-tile>
                          <v-list-tile>
                        <v-list-tile-content><b>Tilaushenkilö</b></v-list-tile-content>
                          <v-flex xs6>
                            <v-select                    
                              v-bind:items="deliveryPerson"
                              v-model="delivery_person_id"
                 
                              label="Valitse Tilaushenkilö"
                              item-text="name"
                              item-value="id"
                              single-line                      
                            ></v-select>
                          </v-flex>                    
                        </v-list-tile>
                        <v-list-tile style="margin-top:10px">
                          <v-list-tile-content><b>Tilauspäivä</b></v-list-tile-content>
                          <v-flex xs12 lg6>
                            <v-menu
                              ref="menu1"
                              :close-on-content-click="false"
                              v-model="menu1"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                            <v-text-field
                              slot="activator"
                              v-model="date"
                              placeholder="Tilauspäivä"
                              persistent-hint 
                            ></v-text-field>
                            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-list-tile>
                      <v-list-tile style="margin-top:10px">
                        <v-list-tile-content><b>Tilausaika</b></v-list-tile-content>
                        <v-flex xs12 lg6>
                          <v-menu
                            ref="menu"
                            :close-on-content-click="false"
                            v-model="menu3"
                            :nudge-right="40"
                            :return-value.sync="time"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="time"
                              placeholder="Tilausaika"                             
                              readonly
                            ></v-text-field>
                            <v-time-picker
                              v-if="menu3"
                              v-model="time"
                              full-width
                              @change="$refs.menu.save(time)"
                            ></v-time-picker>
                          </v-menu>
                        </v-flex>
                      </v-list-tile>
                    </v-list>
                  </div>
                  <br>
                  <v-divider></v-divider>
                  <v-flex  class="order_action justify-center py-2" > 
                    <v-btn  @click="orderProcessing(order.id)" small color="primary" dark>Työn alla</v-btn>
                    <v-btn @click="orderComplete(order.id)" small color="success" dark>Valmistunut</v-btn>
                    <v-btn @click="orderCancelled(order.id)" small color="error" dark>Peruttu</v-btn>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex xs12 md7>
                <v-card>
                  <v-card-title><h4>Ostoskorin Tuotteet</h4></v-card-title>             
                  <v-divider></v-divider>
                  <v-data-table
                  :headers="headers"
                  :items="order.cart"
                  :search="search"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  row
                  wrap
                  class="elevation-1 mx-3"
                  >
                  <template slot="items" slot-scope="props">                            
                    <td class="text-xs-left"><v-img :src="props.item.product.image" aspect-ratio="1" style="width:55px;"> </v-img></td>
                    <td class="text-xs-left">{{ props.item.product.item_name }}</td>
                    <td class="text-xs-left">{{ props.item.product.vat_percent }}</td>
                    <td class="text-xs-left">{{currency}}{{ parseFloat(props.item.product.price).toFixed(2) }}</td>
                    <td class="text-xs-left">{{ props.item.product.quantity }}</td>
                    <td class="text-xs-left">{{currency}}{{parseFloat(props.item.product.quantity * props.item.product.price).toFixed(2)}}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <div class="text-center"> 
              <v-snackbar
                v-model="processingSnackbar"
                :timeout="timeout"
              >
                {{ orderProcessingText }}             
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
            <div class="text-center"> 
              <v-snackbar
                v-model="completeSnackbar"
                :timeout="timeout"
              >              
                {{ orderCompleteText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
            <div class="text-center"> 
              <v-snackbar
                v-model="cancelledSnackbar"
                :timeout="timeout"
              >              
                {{ orderCancelledText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
               <div class="text-center"> 
              <v-snackbar
                v-model="notreadySnackbar"
                :timeout="timeout"
              >              
                {{ pdfnotreadyText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
          </v-layout>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import firebase from "firebase";
  import moment from 'moment'
    import axios from "axios";
  export default {
    name:'ViewOrder',
    components: {
      Navbar
    },
    data(){
      return{
        rowsPerPageItems: [8, 16, 24],
        pagination: {
        rowsPerPage: 8
        },     
        order:[],      
        current_month_name:moment().format('MMMM'),
        current_year:moment().format('YYYY'),    
        currency:'',
        headers: [                
          { text: 'kuva' , value: 'image', sortable: !1 },  
          { text: 'tuote' , value: 'item_name', sortable: !1 },  
          { text: 'alv-%' , value: 'vat_percent', sortable: !1 },  
          { text: 'hinta' , value: 'price', sortable: !1 },
          { text: 'määrä' , value: 'quantity', sortable: !1 },
          { text: 'summa' , value: 'timestamp', sortable: !1 },                                         
        ],
        search:'',
        order_status:null,
        snackbar:false,
        processingSnackbar: false,
        completeSnackbar: false,
        cancelledSnackbar: false,
        notreadySnackbar: false,
        orderProcessingText: 'Tilausta käsitellään',
        orderCompleteText: 'Tilaus on valmis',
        orderCancelledText: 'Tilaus peruutetaan',
        pdfnotreadyText: 'Tilauslomake ei ole täydellinen. Yritä myöhemmin uudelleen.',
        timeout: 3000,
        deliveryPerson:[],
        adminPerson:[],
        delivery_person_name:this.delivery_person_name,
        delivery_person_id:this.delivery_person_id,
        admin_person_name:this.admin_person_name,
        admin_person_id:this.admin_person_id,
        date:this.date,
        time:this.time,
        menu1: false,
        menu3: false,     
        delivery:[],     
      }
    },
    methods:{   
      orderProcessing(id){       
        var db = firebase.firestore(); 



  let orderRef = db.collection('orders').doc(this.$route.params.id);
  orderRef.get().then(doc=>{

let ordertime=doc.data().timestamp;
let pdfstatus=doc.data().pdfurl;
let orderstatus=doc.data().order_status;

if(orderstatus=="Processing" || orderstatus=="Complete")
{

  this.pdfnotreadyText="tilaus on jo käsitelty"
this.notreadySnackbar = true  

return;
}

// if(pdfstatus!=null)
// {

        // Change order status
        let orderRef = db.collection('orders').doc(this.$route.params.id);
          orderRef.update({            
            order_status:"Processing"   
        })

  let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendOrderPushMail?userid="+this.$data.order.user_id+"&type=processing"+"&orderid="+this.$data.order.path).
 // let res =  axios.get("http://localhost:5001/elatukku-23ef3/europe-west1/sendOrderPushMail?userid="+this.$data.order.user_id+"&type=processing"+"&orderid="+this.$data.order.path).
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });



        // Delivery person için trigger kullanarak bildirim göndereceğiz!
        // Order processing for delivery 

var delivername="";
var adminname="";
        this.deliveryPerson.forEach(deliver=>{
          if(deliver.id==this.delivery_person_id)
          delivername=deliver.name
        })
          this.adminPerson.forEach(admin=>{
          if(admin.id==this.admin_person_id)
          adminname=admin.name
        })

console.log("reached here1" +delivername)

        if(this.delivery_person_id && this.admin_person_id && this.date && this.time){
        let deliveryRef = db.collection('deliveries').doc(this.$route.params.id);
        deliveryRef.set({
          id:this.$route.params.id,
          order_id:this.order.path,
           delivery_person_name:delivername,
          delivery_person_id:this.delivery_person_id,
          admin_person_name:adminname,
          admin_person_id:this.admin_person_id,
          date:this.date,
          time:this.time,
          delivery_status:"Processing",
          duration:60,      
          created_date:moment().format('DD-MM-YYYY'),
          created_month:moment().format('MM-YYYY'),
          timestamp:Date.now()
        }).catch(error=>{
          console.log("error:" + error)
        })

  

  let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendDeliveryInfo?adminid="+this.admin_person_id+"&orderid="+this.$data.order.path+"&depocuid="+this.delivery_person_id+"&date="+this.date+"&time="+this.time).
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });

        this.delivery_person_name=null
        this.admin_person_name=null
        this.date=null
        this.time=null
        }
        this.processingSnackbar = true    
// }
// else
// {
//    var now = moment();

//   var duration=moment.duration(now.diff(ordertime*1000))
// var minx= 7 - duration.minutes();

//   this.pdfnotreadyText="Tilauslomake ei ole täydellinen. odotusaika "+ minx + " minuuttia"
// this.notreadySnackbar = true  
// }
  })



// let res2 =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendDeliveryPushMail?orderid="+this.$data.order.id+"&userid="+this.$data.order.user_id).
//                 then(res=> {
//                   console.log(res.data)
//                 })
//                   .catch(error => { console.log(error); });



      },
      orderComplete(id){       

   console.log(this.$data.order);
 // console.log(order);
 
    // let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendOrderCompleteMail?dest="+this.$data.order.user_id).
    //             then(res=> {
    //               console.log(res.data)
    //             })
    //               .catch(error => { console.log(error); });

                //   let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendMailPush?userid="+this.$data.order.user_id+"&orderid="+this.$data.order.id).
                // then(res=> {
                //   console.log(res.data)
                // })
                //   .catch(error => { console.log(error); });

                //       let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendMailPush?userid="+this.$data.order.user_id+"&orderid="+this.$data.order.id).
                // then(res=> {
                //   console.log(res.data)
                // })
                //   .catch(error => { console.log(error); });
                  
       var db = firebase.firestore(); 


  let orderRef = db.collection('orders').doc(this.$route.params.id);
  orderRef.get().then(doc=>{

let pdfstatus=doc.data().pdfurl;
let orderstatus=doc.data().order_status;

if(orderstatus=="Complete")
{

  this.pdfnotreadyText="tilaus on jo valmis"
this.notreadySnackbar = true  

return;
}

// if(pdfstatus!=null)
// {
//console.log("status:" +pdfstatus)

let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendOrderPushMail?userid="+this.$data.order.user_id+"&type=completed"+"&orderid="+this.$data.order.path).
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });


        var db = firebase.firestore(); 
        let ref = db.collection('orders').doc(this.$route.params.id);
          ref.update({            
            order_status:"Complete",
             pdfready:true,  
            created_date:moment().format('DD-MM-YYYY'),
            created_month:moment().format('MM-YYYY'),               
            created_year:moment().format('YYYY'),                    
        })
        let deliveryRef = db.collection('deliveries').doc(id);
            deliveryRef.update({            
            delivery_status:"Complete"
                   
        })
        
        this.completeSnackbar = true    
// }
// else
// {
//      var now = moment();

//   var duration=moment.duration(now.diff(ordertime*1000))
// var minx= 7 - duration.minutes();

//   this.pdfnotreadyText="Tilauslomake ei ole täydellinen. odotusaika "+ minx + " minuuttia"
// this.notreadySnackbar = true  
// }
  })
      },
      orderCancelled(id){       
        var db = firebase.firestore(); 

 let orderRef = db.collection('orders').doc(this.$route.params.id);
  orderRef.get().then(doc=>{

let pdfstatus=doc.data().pdfurl;
let orderstatus=doc.data().order_status;

if(orderstatus=="Complete")
{

this.pdfnotreadyText="tilaus on jo valmis"
this.notreadySnackbar = true  

return;
}
else
{
         orderRef.update({            
            order_status:"canceled"          
        }) 

 let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendOrderPushMail?userid="+this.$data.order.user_id+"&type=canceled").
 //let res =  axios.get("http://localhost:5001/elatukku-23ef3/europe-west1/sendOrderPushMail?userid="+this.$data.order.user_id+"&type=canceled").

                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });

        this.cancelledSnackbar = true    
}
  });
 
      }
    },
    created(){
      var db = firebase.firestore(); 

      // Current Currency
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.currency = doc.data().currency
      })

      // Show data of a specific Order
      var db = firebase.firestore(); 
      db.collection("orders").doc(this.$route.params.id).onSnapshot(doc =>{
        this.order = doc.data()
        this.order.id = doc.id

          if(doc.data().order_status=='Pending')
        this.order.order_status='Odottaa'
          if(doc.data().order_status=='Processing')
        this.order.order_status='Tilattu'
             if(doc.data().order_status=='Complete')
        this.order.order_status='Valmis'
         if(doc.data().order_status=='canceled')
        this.order.order_status='Peruutettu'


      })
      
      // Show All Delivery Person
      let ref = db.collection('delivery_person').where("role","==","Delivery")   
      ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type == 'added'){
            let doc = change.doc
            this.deliveryPerson.push({
              id:doc.id,
              name:doc.data().name
            })
          }
        })
      }) 
        // Show All Admin Person
      let ref2 = db.collection('delivery_person').where("role","==","Admin")    
      ref2.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type == 'added'){
            let doc = change.doc
            this.adminPerson.push({
              id:doc.id,
              name:doc.data().name
            })
          }
        })
      }) 
      // Delivery details
      db.collection("deliveries").doc(this.$route.params.id).onSnapshot(doc =>{
        this.delivery = doc.data()      
      })
    }
  }
</script>

<style scoped>
  .view_order .elevation-1{
    margin:0!important;
  }
  tbody a{
    font-size: 13px;
    color:black;
    text-decoration: underline;
  }
  h1{
    width: 100%;
  }
  h4{
    width: 100%;
  }
  .updates-heading{
    margin-left: 25px;
  }
  light.divider, .theme--light .divider {
    background-color: rgba(0,0,0,.12);
  }
  .monthy_total{
    float: right;
    margin-left: 50px;
  }
  .order_action{
    width:100%;
    display:flex;
    text-align: center;
  }
  .primary--text {
    color: #345B2C !important;
    caret-color: #345B2C !important;
}

 .v-picker__title.primary{
    background-color: #345B2C !important;
    border-color: #345B2C !important;
}

  @media (max-width:346px){
    .order_action{
      width:100%;
      display:grid;
      text-align: center;
    }
    .v-btn {
      height: 36px;
      font-size: 14px;
      font-weight: 500;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin: 6px 8px;
      min-width: 100%!important;
    }
  }
  .v-date-picker-table .v-btn.v-btn--active {
    background-color: #345B2C !important;
    border-color: #345B2C !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/orders/ViewOrder.vue